import Action from '../../Action'
// import './styles/ModalDeleteUSer.css'
import { useState,useEffect } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
// import './Maintenance-styles/ModalAddHost.css'
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';
const ModalHostStatusList =({source,statusSelectedText,statusSelected,server,languaje,handleShowPopup,mode,hosts,elementsList,SetElementList,setDataWorkFlow,dataWorkFlow,brand,closHostsListModal})=>{
  const [poolRows,setPoolRows]=useState([])
  const [allSelected, setAllSelected] = useState(false);
  // const [hostSelected,setHostSelected]=useState(hosts.filter(item => poolRows.includes(item.hostid)))
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  const [response,setResponse]=useState([])
  var dataList = searchTerm === "" ? statusSelected : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [loadingM,setLoadingM]=useState(false);
  const [exportLoading,setExportLoading]=useState(false)

  const handleSelectAll = () => {
      if (allSelected) {
        // Si ya está todo seleccionado, deselecciona todo
        setPoolRows([]);
      } else {
        setPoolRows(hosts.map(item => item.hostid))
      }
      setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
    };
  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value);setPageActual(1);
  };
  /************************************************* */
  /************************************************* */
  /************************************************* */
  /*******************seleccionar host ************* */
  /************************************************* */
  /************************************************* */
  /************************************************* */
  const Exportar=(file_type)=>{

    let method='POST'
const body={
  "file_type": file_type,
  "brand_ids": poolRows
}
    setExportLoading(true)
      const fetchDataPost = async () => {
        
     try {
       // console.log(localStorage.getItem('access_token'))
       const response = await fetch(server.url+'/api/v1/cassia/monitoring_devices/status_report/custom-tabs/'+source+'_excel/'+brand.groupid, {
         method: 'GET',  
         headers: {
            "Accept": "application/json",
           // 'Content-Type': 'application/json',
           'Content-Type': 'application/json',
             Authorization: `Bearer ${localStorage.getItem('access_token')}`,
           },
         // body: JSON.stringify(body),
       });
       if (response.ok) {
        // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
     const blob = await response.blob();
     const url = window.URL.createObjectURL(blob);
     const link = document.createElement('a');
     link.href = url;

     // Dependiendo del tipo de archivo, nombramos el archivo a descargar
     if (file_type === 'json') {
       link.download = 'Marcas.json';
     } else if (file_type === 'csv') {
       link.download = 'Marcas.csv';
     } else if (file_type === 'excel') {
       link.download = source+'_'+brand.group_name+'.xlsx'; // Archivo de Excel
     }

     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
     setAllSelected(false)
     setPoolRows([])
     setExportLoading(false);
     handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])),'', true)

       } else {
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
           
        }
      };
  
      fetchDataPost();
      
}
  function normalizeHostToCSVRow(item) {
    return {
      id: item.id,
      host: item.name,
      ip: item.ip ?? '',
      status: (item.status=='ok'?'Conectado':(item.status=='offline'?'Desonectado':'Desconocido')),
      'en excepcion': (item.is_exception?'Si':'No'),
      'en mantenimiento': (item.in_maintenance?'Si':'No'),
      'Tiempo Desconexión (formato horas)': item.duration ?? '',
      'Tiempo Desconexión (formato Fecha)': item.disconnected_since ?? '',

      tecnologia: item.tech?.name ?? '',

      zonas: Array.isArray(item.zones)
        ? item.zones.map(z => z.name).join(' | ')
        : '',

      grupos: Array.isArray(item.groups)
        ? item.groups.map(g => g.name).join(' | ')
        : '',

      afiliacion: item.parent_id ?? ''
    };
  }
  function arrayToCSV(data) {
    if (!Array.isArray(data) || data.length === 0) return '';

    const headers = Object.keys(data[0]);
    const csvRows = [];

    csvRows.push(headers.join(','));

    data.forEach(row => {
      const values = headers.map(header => {
        const val = row[header];
        return `"${String(val).replace(/"/g, '""')}"`;
      });
      csvRows.push(values.join(','));
    });

    return csvRows.join('\n');
  }
  function downloadCSV(hostsArray, filename = 'hosts.csv') {
    const normalized = hostsArray.map(normalizeHostToCSVRow);
    const csvContent = arrayToCSV(normalized);

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
  }

  //   const search_host_list_by_source=()=>{


  //     setLoadingM(true)
  //       const fetchDataPost = async () => {

  //      try {
  //       // let urlSource=(source=='byGroupID')?'host_groups/hosts_list/'+brand.groupid:'hosts/byTemplateID/'+brand.templateid
  //       // console.log('/api/v1/cassia/'+urlSource)
  //           const response = await fetch(server.url+'/api/v1/cassia/monitoring_devices/status_report/custom-tabs/'+source+'/'+brand.groupid, {
  //             method: 'GET',  
  //             headers: {
  //               'Content-Type': 'application/json',
  //               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
  //             },
  //             // body:JSON.stringify(host_list)
  //           });
  //          console.log(response)
  //           if (response.ok) {

  //             const data1 = await response.json();
  //             setLoadingM(false)
  //             // Manejo de la respuesta
  //             // setData(data1)
  //             // setStatusResponseDelete(true)
  //             console.log(data1.data)
  //             setResponse(data1.data)
  //             // buscar_cis()
  //             // handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regDeleteCorr'])),'', true)
  //             // closDeleteUserModal()

  //             // console.log(data1);
  //           } else {
  //             const data1 = await response.json();
  //           handleShowPopup('Error!!!',data1.detail,capitalizeFirstLetter(lang[languaje]['reportError']), false)
  //           // setError(error)
  //             throw new Error('Error en la solicitud');
  //           }
  //         } catch (error) {
  //           // Manejo de errores
  //           // const data1 = await response.json();
  //           handleShowPopup('Error!!!','',capitalizeFirstLetter(lang[languaje]['reportError']), false)
  //           // setError(error)
  //           console.error(error);
  //         }
  //       };

  //       fetchDataPost();

  // }
  const WarningIcon = () => (
<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
<path
  d="M12 2L2 20h20L12 2z"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
/>
<line
  x1="12"
  y1="9"
  x2="12"
  y2="14"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
/>
<circle
  cx="12"
  cy="17"
  r="1"
  fill="currentColor"
/>
</svg>
);


  const ToolsIcon = () => (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
   width="18" height="18" viewBox="0 0 1280 1230" preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0 1230) scale(0.1 -0.1)" fill="currentColor" stroke="none">
      <path d="M9265 12294 c-782 -78 -1373 -456 -1688 -1079 -182 -360 -257 -728
  -257 -1260 0 -188 8 -276 47 -505 34 -206 37 -357 7 -421 -26 -56 -82 -120
  -140 -160 -24 -16 -1590 -1444 -3480 -3174 -1891 -1730 -3445 -3145 -3454
  -3145 -10 0 -38 -22 -63 -49 -271 -290 -311 -750 -97 -1115 22 -37 40 -75 40
  -83 0 -8 19 -51 42 -95 68 -132 175 -268 209 -268 9 0 183 -149 386 -331 202
  -183 402 -357 445 -389 284 -213 680 -276 1010 -161 135 47 350 184 356 227 3
  22 71 90 1282 1284 432 426 958 946 1170 1155 212 210 1110 1096 1995 1969
  886 874 1711 1690 1835 1815 342 345 332 343 720 150 431 -213 664 -283 988
  -295 423 -16 805 60 1111 222 497 263 835 712 981 1304 15 63 33 144 39 180 6
  36 18 112 28 170 23 133 25 549 4 590 -20 38 -53 70 -71 70 -20 0 -419 186
  -441 206 -9 8 -37 14 -70 14 -48 0 -157 -39 -870 -314 -448 -172 -817 -311
  -821 -307 -12 11 -1070 1792 -1066 1796 1 1 374 233 828 515 454 282 843 530
  864 551 36 34 40 44 44 97 4 55 2 62 -31 105 -19 25 -51 72 -71 105 -31 52
  -51 69 -144 130 -397 257 -790 418 -1168 477 -95 15 -416 27 -499 19z"/>
    </g>
  </svg>

  );
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0 });

  const handleMouseMove = (e) => {
    setTooltip({
      visible: true,
      x: e.clientX + 10, // un poco a la derecha del cursor
      y: e.clientY - 30, // un poco abajo del cursor
    });
  };

  const handleMouseLeave = () => {
    setTooltip((t) => ({ ...t, visible: false }));
  };
  return(
      <>
      <div className="modal-GS-content">
      <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                  Listado de dispositivos  {statusSelectedText} 
                  </div>
              </div>
              <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin',display:'block'}}>
                  <div className='half-content-card-modal-gs' style={{width:'100%',height:'90%'}}>
                  <>
 <div className='head-cis'>
  <div className='title-cis'>
              <Search
                  searchResults={searchResults}
                  setSearchResults={setSearchResults}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  onSearch={handleSearch}
                  dataObject={statusSelected}
                  searchResult={searchResult}
                  setSearchResult={setSearchResult}
                  languaje={languaje}
                />
        <div className={"cont-result-registers"+mode} style={{width:'25%',bottom:'0px'}}>
       
                <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                  &nbsp;
                  {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                    dataList.length +
                    ") " 
                    }
                </p> 
        </div>
       
             
           
              </div>
              
          </div>
          <div className='cont-cis'>
          <>
    <div className="main-panel-cis">
    <div className="compact-content-portafolio">
    <div className={"content-portafolio-head"+mode}>
    <>
                    <div style={{fontSize:'var(--font-size-xSmall',width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',color:'var(--txt-color)'}}>
                     
                    </div>
                    {(exportLoading)?<div className="cont-excels-buttons-portafolio cont-result-registers"  style={{position:'absolute'}}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div>:
                    <>
                    <div className="cont-excels-buttons-portafolio" style={{position:'absolute'}}>
        {/* <div className="half-excels-buttons-portafolio">
                      
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  src={"/iconos/csv_icon.png"}
                  name="regresar"
                  onClick={()=>Exportar('csv')}
                  style={{opacity:(contRowsSelected==0)? '0.3':'1',
                    pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'CSV  '}
                      </div>
                    </div> */}
                   {/* <div className="half-excels-buttons-portafolio">
                      
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  src={"/iconos/json_icon.png"}
                  name="regresar"
                  onClick={()=>Exportar('json')}
                  style={{opacity:(contRowsSelected==0)? '0.3':'1',
                    pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'JSON'}
                      </div>
                    </div> */}
                    <div className="half-excels-buttons-portafolio">
                    
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  src={"/iconos/csv_icon.png"}
                  name="regresar"
                  onClick={()=>downloadCSV(statusSelected, 'reporte_dispositivos_'+statusSelectedText+'.csv')}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                      {' CSV'}
                      </div>
                    </div>
               </div>
               </>
                    }
                    </>
            </div>
      <div className="content-portafolio">
        <div className="cont-portafolio-table">
          <div className="content-card-portafolio" id="content">
           
          <div className="cont-table-portafolio">
    <div className={"head-table-portafolio"+mode}>
    <div className="compact-head-table-portafolio">
    {/* <div className="field-head-table-mantenimiento field-medium">  <div className='cont-checkbox'>
               <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}} onChange={()=>console.log("all")}  onClick={()=>handleSelectAll()} ></input>
              </div></div> */}
      {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
      <div className="field-head-table-mantenimiento field-medium" style={{width:'20%'}}>{'Afiliacion'}</div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}} >{capitalizeFirstLetter(lang[languaje]['dispositivo'])} </div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{'IP'} </div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{capitalizeFirstLetter(lang[languaje]['tecnologia'])} </div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{capitalizeFirstLetter(lang[languaje]['ubicacion'])} </div>
     
      </div>
    </div>
    <div className="body-table-portafolio">
     
    <>
    <div className="cont-row-user-list">
      {(
        loadingM?<div className="cont-load-user-list">
        <LoadSimple></LoadSimple>
      </div>:
        dataList
          .slice((dataList.length<limitList?0:startLimit), parseInt(pageActual) * parseInt(limitList))
          .map((elemento, indice) => (
            <div
              className={" row-table-portafolio"+mode +" tooltip-container"}
              key={indice}
             onMouseMove={handleMouseMove}
    onMouseLeave={handleMouseLeave}
            >
               
              {/* <div className="field-body-table-mantenimiento field-small">
                {elemento.hostid}
              </div> */}
              <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                <span class={"point-title "+(elemento.status=='ok'?'up':(elemento.status=='offline'?'down':'unknown'))}></span> &nbsp;&nbsp;
               {elemento.is_exception?
<span className="FileIcon" style={{color:'purple'}}><WarningIcon />&nbsp;</span>:''
}
{elemento.in_maintenance?
<span className="FileIcon" style={{color:'rgb(255, 174, 0)'}}><ToolsIcon />;&nbsp;</span>:''
}
                &nbsp;{elemento.parent_id}
              </div>
              <div className="field-body-table-mantenimiento field-larger" style={{width:'40%'}}>
                {elemento.name}
              </div>
              <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                {elemento.ip}
              </div>
              <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                {elemento.tech.name}
              </div>
             <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                {elemento.zones[0]?.name}
              </div>
              
              {<div className="tooltip-content"onClick={(e)=>e.stopPropagation()}  style={{left:'50%',width:'auto',minWidth:'20%',maxWidth:'50%',boxShadow:'0px 0px 10px rgba(0, 0, 0, 0.34)',padding:'10px',borderRadius:'5px',zIndex:1000, overflowY:'auto',maxHeight:'250px',position: "fixed",background: 'var(--white-color)',color: 'var(--txt-color)',
          top: tooltip.y,
          left: tooltip.x}}>
                                          {
                                            <>
                                              <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'5px'}}>
                                               <div style={{fontWeight:'bold'}}>GRUPOS:</div>
                                               {elemento.groups.map((group,idx)=>(
                                                 <div>{group.name} </div>
                                               ))}
                                                
                                              </div>
                                              {/* <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'5px'}}>
                                                <div style={{fontWeight:'bold'}}>Afiliación:</div>
                                                <div>{elemento.affiliation} </div></div>
                                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'5px'}}>
                                                <div style={{fontWeight:'bold'}}>Incidencia:</div><br></br>
                                                <div>{elemento.Problem} </div></div> */}
                                                </>
                                                
                                           }
                                           
                                         
          </div>}
             
            </div>
          ))
      )}
      { (dataList.length == 0 ) ? (
        <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
      ) : (
        ""
      )}
    </div>
    
  </>
    </div>
  </div>
          </div>
        </div>

        </div>
        <div className={"content-portafolio-footer"+mode}>
        <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
          
          {/* <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                    </p> 
                
          </div> */}
        </div>  
        <div className="cont-display-paginador" style={{width:'60%'}}>
                  <Paginador  pages={pages}
                              pageActual={pageActual}
                              setPageActual={setPageActual}
                              mode={mode}></Paginador>
        </div>
        <div className="cont-display-paginador" style={{width:'50%'}}>
          <div className={"cont-half-display-paginador"+mode}>
                    
          <div>
    <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
    <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
      <option value={10}>10</option>
      <option value={50} >50</option>
      <option value={100}>100</option>
      <option value={500}>500</option>
      <option value={1000}>1000</option>
    </select>

    
  </div>
          </div>
          <div className={"cont-half-display-paginador"+mode} >
          <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall) !important'}}>
                          &nbsp;
                          {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length > parseInt(pageActual ) * parseInt(limitList)
                        ? parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']}
                    </p>
                    {/* {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                        ?  parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']} */}
          </div>
        </div>  
                  
      </div>
      </div>
    </div>
    
  </>
              
          </div>
 </>
    
                  </div>
                  <div className='contentButtomsWorkflow'>
                  <div className="form-GS-box"> 
                  <div className="user-box-GS" style={{height:'100%'}}>
                                      {
                                          (false)?<LoadSimple></LoadSimple>
                                          :
                                          <>
                                          {/* <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={()=>{cancelItem()}}/> */}
                                          <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['aceptar'])}  action={closHostsListModal}/>
                                          </>
                                          // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                      }
                                          
                                  {
                                      // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                  }
                                      
                                  </div>
                                  </div>
                  </div>
                  {/* <div className='half-content-card-modal-gs'>
                  <>
              <div className='head-cis'>
              <div className="cont-buttons-panel" style={{width:'50%'}}>
                
                <Action
                disabled={false}
                origen="Azul"
                titulo={""+capitalizeFirstLetter(lang[languaje]['Aceptar'])}
                action={closeAddHostModal}
              />
                
                  
                
               
              </div>
              
              </div>
          <div className='cont-cis'>
          <>
    <div className="main-panel-cis">
    <div className="compact-content-portafolio">
    <div className={"content-portafolio-head"+mode} style={{background:'var(--third-color)',color:'var(--white-color)'}}>
              <div className='title-host-added'>{capitalizeFirstLetter(lang[languaje]['hostSelected'])}</div>
            </div>
      <div className="content-portafolio">
        <div className="cont-portafolio-table">
          <div className="content-card-portafolio" id="content">
           
          <div className="cont-table-portafolio">
    
    <div className="body-table-portafolio">
     
    <>
    <div className="cont-row-user-list">
      
      {(
        hostSelected
          .map((elemento, indice) => (
              <div className='content-row-host-selected' key={indice}>
              <div className='row-host-selected'>
                  <div className='text-host-selected'>
                  {elemento.host}
                  </div>
                  <div className='delete-host-selected' onClick={(()=>rowSelected(elemento))}>
                                  X
                  </div>
              </div>              
          </div>
          ))
      )}
      { (dataList.length == 0 ) ? (
        <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
      ) : (
        ""
      )}
    </div>
    
  </>
    </div>
  </div>
          </div>
        </div>

        </div>
        <div className={"content-portafolio-footer"+mode} style={{justifyContent:'center'}}>
        <div className="cont-display-paginador" style={{position: 'absolute',justifyContent: 'center',width:'50%'}}>
          
          <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {"("+hostSelected.length+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados'])}
                    </p> 
                
          </div>
        </div>  
        
         
                  
      </div>
      </div>
    </div>
    
  </>
              
          </div>
 </>
                  </div> */}
              </div>
          </div>
          </div>
      </>
  )
}

export default ModalHostStatusList